import { Account } from '@/domain/usecases'
import { upgradeRequestService } from '@/data/services/upgrade/upgrade-service'

/**
 * Loads upgrade request data
 * Fetches upgrade settings and pending requests for user's company
 */
export async function loadUpgradeRequest(account: Account.Model) {
  const [upgradeSettings, upgradeRequestStatus] = await Promise.all([
    upgradeRequestService.fetchSettings(account.company.uniqueId),
    upgradeRequestService.fetchPendingRequests(account.company.uniqueId)
  ])

  return {
    ...upgradeSettings,
    pendingResponse: upgradeRequestStatus
  }
}
